// extracted by mini-css-extract-plugin
module.exports = {"PaginationContainer":"Pagination_PaginationContainer__2Kg7Y","PageButton":"Pagination_PageButton__1d0IH"};